var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-error"},[_c('span',{staticClass:"icon-data-error"}),_c('p',[_vm._v("系统繁忙，请稍后再试！")])])}]

export { render, staticRenderFns }